(function(){
  var variantToSKU = {
     '4264589765': '8ZULW',
     '4264589829': '16ZULW',
     '4264601477': 'RA1412',
     '10580796293': '16ZULW-B',
    '10690708037': '16RACHBX',
     '4628625413': 'SRV-INSTL-D'
  };

  [].forEach.call(document.querySelectorAll('#cart .action.remove'), function(elm){
    elm.addEventListener('click', function(evt){
      evt.preventDefault();
      CartJS.removeItemById(Number(this.getAttribute('data-variant-id')));
      setTimeout(function(){document.location.reload();}, 600);
    });
  });
}());